var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcLoanPortfolioManagementSmall = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-3{fill:none}.cls-2,.cls-4{fill:#5f7278}.cls-3{stroke:#5f7278;stroke-width:2px;stroke-dasharray:62 12}.cls-4{font-size:15px;font-family:Roboto-Medium,Roboto;font-weight:500}.cls-5{stroke:none}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "ic_loan_portfolio_management",
  transform: "translate(-495 -118)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_142",
  d: "M0 0h34v34H0z",
  className: "cls-1",
  "data-name": "Rectangle 142",
  transform: "translate(495 118)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1063",
  "data-name": "Group 1063"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_155",
  width: 6,
  height: 1.5,
  className: "cls-2",
  "data-name": "Rectangle 155",
  rx: 0.75,
  transform: "translate(509 121)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_156",
  d: "M0 0h2v4H0z",
  className: "cls-2",
  "data-name": "Rectangle 156",
  transform: "translate(511 121)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_15",
  className: "cls-3",
  "data-name": "Ellipse 15",
  transform: "translate(499 124)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 13,
  r: 13,
  className: "cls-5"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 13,
  r: 12,
  className: "cls-1"
})), /*#__PURE__*/React.createElement("text", {
  id: "_",
  className: "cls-4",
  "data-name": "$",
  transform: "translate(508 142)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "$")), /*#__PURE__*/React.createElement("path", {
  id: "Polygon_4",
  d: "M3 0l3 5H0z",
  className: "cls-2",
  "data-name": "Polygon 4",
  transform: "translate(497.3 133)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcLoanPortfolioManagementSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_loan_portfolio_management_small.a1b62331b17d90ad12938a80e8cb57d8.svg";